import { useTranslation } from "react-i18next"
import ModalPortal from "../../Assets/ModalPortal/ModalPortal"
import styles from "./ManualCodeModal.module.scss"
import React, { Dispatch, SetStateAction, useState } from "react"
import { clsx } from "clsx"
import Button from "../../Assets/Button/Button"
import { PatternFormat } from "react-number-format"
import { useLazyGetObjectIdInCodeQuery } from "../../../redux/api/main"
import { useNavigate } from "react-router-dom"
import moment from "moment"

interface Props {
  isOpen: boolean
  setIsOpen: Dispatch<SetStateAction<boolean>>
  afterScanningFunc?: (time?: string, objectID?: string) => void
  afterNavigate?: (obj: string) => void
  values: any
}

const ManualCodeModal: React.FC<Props> = ({ isOpen, setIsOpen, afterScanningFunc, afterNavigate, values }) => {
  const { t, i18n } = useTranslation("translation", { keyPrefix: `interface` })
  const navigate = useNavigate()

  const [inputCode, setInputCode] = useState<null | number>(null)
  const [errCode, setErrCode] = useState<string>("")
  const [getObjectIdInCode, { isLoading }] = useLazyGetObjectIdInCodeQuery()

  const closeModal = () => {
    setIsOpen(!open)
    setErrCode("")
    setInputCode(null)
  }

  const sendCode = () => {
    if (inputCode) {
      getObjectIdInCode(inputCode)
        .unwrap()
        .then((res) => {
          if (!res.success && res.errorCode === "NotFound") {
            setErrCode(t(`codeErrors.${res.errorCode}`))
          } else if (res?.data?.id) {
            const dataCreatedAt = new Date().valueOf() / 1000
            const time = dataCreatedAt
              ? moment(dataCreatedAt * 1000).format("DD.MM.YYYY HH:mm")
              : moment().format("DD.MM.YYYY HH:mm")
            if (afterScanningFunc) {
              if (res?.data?.id === values?.technical_object_id) {
                afterScanningFunc(time, res?.data?.id)
              } else {
                setErrCode(t(`codeErrors.WrongId`))
              }
            } else {
              const resDataID = res.data.id
              sessionStorage.setItem("QRScanDate", JSON.stringify(time))
              if (afterNavigate) {
                afterNavigate(`/object/${resDataID}`)
              } else {
                navigate(`/object/${resDataID}`)
              }
            }
          }
        })
        .catch((err: any) => {
          if (err.status === "FETCH_ERROR") {
            setErrCode(t(`codeErrors.FetchError`))
          }
        })
    }
  }

  const [isFocused, setFocused] = useState(false)

  return (
    <ModalPortal
      isOpen={isOpen}
      setIsOpen={closeModal}
      className={clsx("lang-modal", styles.modal, isFocused && styles.inputFocused)}
    >
      <div className={styles.modal__wp}>
        <div className={`modal-head`}>
          <div className={`modal-title`}>{t("enterCode")}</div>
        </div>
        <div className={styles.modal__body}>
          <div className={styles.modal__label}>{t("getCodeTechSupport")}</div>
          <div className={styles.modal__input}>
            <PatternFormat
              format="####"
              allowEmptyFormatting
              mask=""
              placeholder="0000"
              value={inputCode}
              onChange={(newVal) => setInputCode(Number(newVal?.target?.value) || null)}
              onKeyDown={(e: any) => {
                if (errCode !== "") {
                  setErrCode("")
                }
              }}
              onFocus={() => setFocused(true)}
              onBlur={() => setFocused(false)}
              className="input"
              name={"qr-code-input-num"}
              autoComplete={"off"}
            />
          </div>
          {errCode && <div className={styles.modal__error}>{errCode}</div>}
        </div>
        <div className={styles.modal__footer}>
          <Button txt={t("back")} mode={"gray"} onClick={() => setIsOpen(!open)} className={styles.btnBack} />
          <Button
            txt={t("confirmBtn")}
            isLoading={isLoading}
            disabled={inputCode === null || String(inputCode).length !== 4 || isLoading}
            onClick={sendCode}
            className={styles.btnBack}
          />
        </div>
      </div>
    </ModalPortal>
  )
}

export default ManualCodeModal
